// removed by extract-text-webpack-plugin
module.exports = {"tooltip":"_1MjQF-qtASDlHUmlqvsoEG","closeBtn":"_30CsYvGjb-MgaPnVUCQBce","realEstateTooltip":"jhfdtFWc59nAza4YAN3lb","rtlPosition":"_3RJEWSVRBzKAu_V3xmPN6W","phoneVerificationTooltip":"_1aJ7LBQH3vgZZ-6IGYd0a6","package":"_1FVWkePoPR_qbxOh4rof5K","packageTooltip":"_3q79QRlJnQyqgBCCvO8Rck","plainPackageTooltip":"_1E6RwzKfSZvydliN2Eqi7x","imageTooltip":"_2MWsjHD2jAH2Yq4-u4N-I4","requiredImageTooltip":"_33Hzfazap7FiW3fbfOwKmP","contact":"_1HDRyaCrkrKnFsJkvqfIqG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMTooltip/OMTooltip.scss
// module id = 1684
// module chunks = 0